class GetVolumeSinceFirstLogUseCase {
  constructor(repository) {
    this.repository = repository;
  }
  async execute(FK_SECTOR,FK_VALVE,START){
    const result= await this.repository.getVolumesSinceFirstLog(FK_SECTOR,FK_VALVE,START)
    return result && result.length?result[0]:[];
  }
}
export {
  GetVolumeSinceFirstLogUseCase,
};
